document.addEventListener("DOMContentLoaded", () => {
    const rows = document.querySelectorAll(".crm-track");

    rows.forEach((row) => {
        // Pause on hover
        row.addEventListener("mouseenter", () => {
            row.style.animationPlayState = "paused";
        });

        row.addEventListener("mouseleave", () => {
            row.style.animationPlayState = "running";
        });
    });
});